import _ from 'lodash';
import {
    Action,
    AppFeature,
    EntityConfig,
    ReadablePermissions,
    UserRole,
} from 'src/stores/UserStore/UserStore.types';

export const userPermissionsConfig: Record<AppFeature, EntityConfig> = {
    tasks: {
        view: [
            UserRole.Superuser,
            UserRole.Verifier,
            UserRole.Underwriter,
            UserRole.CreditOfficer,
            UserRole.CollectionManager,
            UserRole.PartnerManager,
            UserRole.RelationshipManager,
            UserRole.Agent,
        ],
        manage: [
            UserRole.Superuser,
            UserRole.Verifier,
            UserRole.Underwriter,
            UserRole.CreditOfficer,
            UserRole.CollectionManager,
            UserRole.PartnerManager,
            UserRole.RelationshipManager,
            UserRole.Agent,
        ],
    },
    applications: {
        view: [
            UserRole.Superuser,
            UserRole.Verifier,
            UserRole.Underwriter,
            UserRole.CreditOfficer,
            UserRole.CollectionManager,
            UserRole.RelationshipManager,
        ],
        manage: [UserRole.Superuser, UserRole.CreditOfficer],
    },
    loans: {
        view: [
            UserRole.Superuser,
            UserRole.Underwriter,
            UserRole.CreditOfficer,
            UserRole.CollectionManager,
        ],
        manage: [UserRole.Superuser, UserRole.CreditOfficer],
    },
    collaterals: {
        view: [
            UserRole.Superuser,
            UserRole.Verifier,
            UserRole.Underwriter,
            UserRole.CreditOfficer,
        ],
        manage: [
            UserRole.Superuser,
            UserRole.Verifier,
            UserRole.Underwriter,
            UserRole.CreditOfficer,
        ],
    },
    borrowers: {
        view: [
            UserRole.Superuser,
            UserRole.Verifier,
            UserRole.Underwriter,
            UserRole.CreditOfficer,
            UserRole.CollectionManager,
            UserRole.RelationshipManager,
        ],
        manage: [
            UserRole.Superuser,
            UserRole.Underwriter,
            UserRole.CreditOfficer,
            UserRole.CollectionManager,
            UserRole.RelationshipManager,
        ],
    },
    products: {
        view: [
            UserRole.Superuser,
            UserRole.Underwriter,
            UserRole.CreditOfficer,
            UserRole.CollectionManager,
        ],
        manage: [UserRole.Superuser, UserRole.CreditOfficer],
    },

    campaigns: {
        view: [
            UserRole.Superuser,
            UserRole.Underwriter,
            UserRole.CreditOfficer,
            UserRole.CollectionManager,
        ],
        manage: [UserRole.Superuser, UserRole.CreditOfficer],
    },
    transactions: {
        view: [
            UserRole.Superuser,
            UserRole.CreditOfficer,
            UserRole.CollectionManager,
        ],
    },
    operations: {
        view: [UserRole.Superuser, UserRole.CreditOfficer],
    },
    collections: {
        view: [
            UserRole.Superuser,
            UserRole.Underwriter,
            UserRole.CreditOfficer,
            UserRole.CollectionManager,
        ],
    },
    agents: {
        view: [UserRole.Superuser, UserRole.PartnerManager],
        manage: [UserRole.Superuser, UserRole.PartnerManager],
    },
    leads: {
        view: [UserRole.Superuser, UserRole.RelationshipManager],
        manage: [UserRole.Superuser, UserRole.RelationshipManager],
    },
    profile: {
        view: [UserRole.Agent],
        manage: [UserRole.Agent],
    },
    agentLoanApplications: {
        view: [UserRole.Agent],
    },
    agentLoans: {
        view: [UserRole.Agent],
    },
    operationsAgent: {
        view: [UserRole.Agent],
        manage: [UserRole.Agent],
    },
    metabaseDashboards: {
        view: [UserRole.Superuser, UserRole.CreditOfficer],
    },
    settings: {
        view: [UserRole.Superuser, UserRole.CreditOfficer],
        manage: [UserRole.Superuser, UserRole.CreditOfficer],
    },
};

export const generateReadablePermissions = (
    userRoles: UserRole[],
    positive: boolean,
) => {
    const allActions: Array<Action> = ['manage', 'view'];

    return Object.fromEntries(
        allActions.map((action) => {
            const calculatedActionPermissions = Object.fromEntries(
                Object.entries(userPermissionsConfig).map(
                    ([entity, entityConfig = {}]: [string, EntityConfig]) => {
                        const actionRoles = entityConfig[action] || [];
                        const canDoActionsWithEntity =
                            _.intersection(actionRoles, userRoles).length > 0;

                        return [
                            entity,
                            positive
                                ? canDoActionsWithEntity
                                : !canDoActionsWithEntity,
                        ];
                    },
                ),
            );

            return [action, calculatedActionPermissions];
        }),
    ) as ReadablePermissions;
};
